import classNames from 'classnames';
import React from 'react';

import {
  FormControl,
  FormHelperText,
  MenuItem,
  Select as MuiSelect,
  makeStyles,
} from '@material-ui/core';

import LabelBlock from './LabelBlock';
import { useErrorStyles } from './form.styles';

const useStyles = makeStyles((theme) => ({
  inputSelect: {
    '& label': {
      transform: 'translate(0, 1.5px)',
      width: '100%',
      '& .label--required': {
        color: theme.palette.primary.main,
      },
      '& .label--icon-valid': {
        color: theme.palette.primary.main,
      },
    },
    '& .MuiSelect-root': {
      backgroundColor: '#ffffff',
      border: '1px solid #999999',
      borderRadius: 4,
      marginTop: '1rem',
      paddingLeft: 6,
    },
    '& .MuiSelect-icon': {
      top: 'calc(50% - 6px)',
    },
  },
}));

type Props = {
  label: string;
  menuItems: {
    label: string;
    value: string;
  }[];
  name?: string;
  value?: string;
  error?: string;
  required?: boolean;
  isErrorVisible?: boolean;
  onChange?: (
    event: React.ChangeEvent<{ name?: string; value: unknown }>,
  ) => void;
  touched?: boolean;
  onBlur?: (event: React.ChangeEvent<HTMLElement>) => void;
  innerRef?: React.MutableRefObject<HTMLInputElement | null>;
};
export const Select: React.FC<Props> = ({
  name,
  label,
  menuItems,
  value,
  error,
  onChange,
  required = true,
  isErrorVisible,
  touched,
  innerRef,
  onBlur,
}) => {
  const { errorFont, errorBlock } = useErrorStyles();
  const classes = useStyles();

  return (
    <FormControl fullWidth className={classes.inputSelect}>
      <LabelBlock
        label={label}
        required={required}
        error={error}
        touched={touched}
        isErrorVisible={isErrorVisible}
      />
      <MuiSelect
        name={name ?? label}
        value={value}
        onChange={(e) => onChange?.(e)}
        onBlur={onBlur}
        ref={innerRef}
      >
        {menuItems.map((item) => (
          <MenuItem key={item.value} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </MuiSelect>
      {error && (touched || isErrorVisible) && (
        <FormHelperText className={classNames(errorFont, errorBlock)}>
          {error}
        </FormHelperText>
      )}
    </FormControl>
  );
};
